import { build_auto_verification_checks } from './onboarding_verification_auto_helpers';
import { build_manual_checks } from './onboarding_verification_manual_helpers';
import { sort_checks_by_last_run } from './onboarding_verification_common_helpers';

export function build_verification_checks(options) {
  const checks = build_auto_verification_checks(options);

  return sort_checks_by_last_run(checks);
}

export function build_manual_verification_checks(options) {
  const checks = build_manual_checks(options);

  return sort_checks_by_last_run(checks);
}
